import React from 'react';
import {Card, Divider} from 'antd-mobile';
import {useNavigate} from 'react-router-dom';
import {DeliveryDetailPath} from "../../../enums/DeliveryNavigatePathEnum";
import {timestampToDate} from "../../../utils/dateTimeUtils";
import {formatLocalizedDateTime} from "../../../utils/dateFormatUtils";
import {formatStopNumber} from "../../../utils/stopNumberUtils";
import {t} from "../../../i18n";

export interface DeliveredOrder {
    id: number,
    trackingNumber: string,
    address: string,
    standardizedAddress?: string,
    routeNumber: string,
    deliveredAt: string,
    fullName: string;
    stopNumber: number;
    subStopNumber?: string | null;
    taskDate?: number | null;
    addressGroupKey?: string | null;
    orderId?: number;
    addressId?: number;
    addressLat?: number;
    addressLon?: number;
}

interface DeliveredCardProps {
    order: DeliveredOrder,
    hideAddress?: boolean;
    isGrouped?: boolean;
    accessEntry?: React.ReactNode;
}

const DeliveredCardTemporary: React.FC<DeliveredCardProps> = ({order, hideAddress = false, isGrouped = false, accessEntry}) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        // 保存主容器的滚动位置
        const mainContainer = document.getElementById('delivered-main-container') as HTMLElement;
        if (mainContainer) {
            sessionStorage.setItem('deliveredPageScrollTop', mainContainer.scrollTop.toString());
        }

        const displayAddress = isGrouped
            ? (order.standardizedAddress || order.address)
            : order.address;
        
        navigate(DeliveryDetailPath.DELIVERY_DELIVERING_ORDER_DETAIL.replace(':trackingNumber', order.trackingNumber),{
            state:{
                deliveryTaskOrderId: order.id,
                trackingNumber: order.trackingNumber,
                detailType:'detail',
                displayAddress: displayAddress,
                fromDeliveringTemporary: true
            }
        });
    };

    return (
        <Card className="my-2 rounded-lg" onClick={handleCardClick}>
            <div className="flex justify-between items-center">
                <div className={`text-base break-all ${isGrouped ? 'font-bold text-black' : 'font-medium'}`}>
                    {order.trackingNumber}
                </div>
            </div>
            <Divider/>
            <div className="flex gap-6">
                <div className="flex flex-col min-w-14 max-w-32 items-center justify-center gap-0.5">
                    {(() => {
                        const stopNumber = formatStopNumber(order.stopNumber, order.subStopNumber);
                        return (
                            <div className={`${stopNumber.length > 4 ? 'text-2xl' : 'text-3xl'} font-bold whitespace-nowrap`}>
                                {stopNumber}
                            </div>
                        );
                    })()}
                    <div className="text-xs">{t('pages.stop')}</div>
                </div>

                <div className="flex flex-col gap-1 flex-1 min-w-0">
                    <h3 className="text-base font-semibold break-all min-w-0">{order.fullName}</h3>
                    {!hideAddress && <p className="break-words min-w-0">{order.address}</p>}
                    <p>
                        {t('pages.delivery.delivered.route')} {order.routeNumber}
                    </p>
                    {order.deliveredAt && (
                        <p>
                            {t('pages.delivery.delivered.deliveredAt')} {formatLocalizedDateTime(timestampToDate(order.deliveredAt))}
                        </p>
                    )}
                    {/* 非聚合地址：门禁信息放到派送成功时间下方 */}
                    {accessEntry && !isGrouped && (
                        <div className="mt-1">
                            {accessEntry}
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default DeliveredCardTemporary;
